import type { EntityListResponse } from '@ydistri/api-sdk';
import type { MultiselectCustomerPartialEntity } from '../../global/ConfigurationMultiselect/configurationMultiselectTypes';

export const toScopeEntityListOptions = (
  entityLists: EntityListResponse[],
  selectedValueIds: number[] = [],
): MultiselectCustomerPartialEntity[] => {
  const selectedValueIdSet = new Set(selectedValueIds);
  const available = entityLists
    .filter(entityList => !entityList.isArchived || selectedValueIdSet.has(entityList.entityListId))
    .map(entityList => {
      const typeNames = entityList.entityListTypes
        .map(entityListType => entityListType.entityListTypeName)
        .join(', ');
      const name = entityList.name ?? 'Unnamed entity list';

      return {
        id: entityList.entityListId,
        customerId: entityList.entityListId.toString(),
        title: name,
        label: `${name}${typeNames ? ` (${typeNames})` : ''}${
          entityList.isArchived ? ' — archived' : ''
        }`,
      };
    });
  const availableValueIds = new Set(available.map(entityList => entityList.id));
  const stale = selectedValueIds
    .filter(valueId => !availableValueIds.has(valueId))
    .map(valueId => ({
      id: valueId,
      customerId: valueId.toString(),
      title: `Entity list ${valueId}`,
      label: `Entity list ${valueId} (stale reference)`,
    }));

  return [...stale, ...available];
};
